import React, { useContext } from "react";
import { Button, Card, List, notification, Tooltip } from "antd";
import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { Link, Persona, PersonaSize, TooltipHost } from "@fluentui/react";
import { observer } from "mobx-react-lite";
import AccountStore from "../store/accountStore";
import {
  generateNewAccountRequestCode,
  getCurrentUser,
} from "../../../../Utility/modules/helpers";
const moment = require("moment");
export const Requests = observer((props) => {
  const accountStore = useContext(AccountStore);
  const { requestdata } = props;
  const styles = {
    bodytext: {
      color: "#1A202C",
    },
    bodyicon: {},
    bodyrow: {
      padding: "10px",
      fontSize: "12px",
    },
  };
  const requestKey = (item, index) =>
    `${item.accountRegisterId}-${item.email}-${item.requestDate}-${index}`;

  return (
    <List
      rowKey={requestKey}
      className={"stylesApplications.filterCardList"}
      grid={{
        gutter: 16,
        xs: 1,
        sm: 2,
        md: 3,
        lg: 3,
        xl: 4,
      }}
      dataSource={requestdata}
      renderItem={(item, index) => (
        <List.Item key={requestKey(item, index)}>
          <Card
            hoverable
            bodyStyle={{ paddingBottom: 20 }}
            actions={[
              <Tooltip key="approve" title="Approve">
                <Button
                  type="link"
                  disabled={accountStore.isworking}
                  icon={<CheckOutlined style={{ color: "#48BB78" }} />}
                  onClick={async () => {
                    try {
                      const approver = getCurrentUser();
                      const reqdata = {
                        requestId: item.accountRegisterId,
                        type: "approved",
                        comment: "",
                        createdBy: approver.fullName,
                        reqcode: generateNewAccountRequestCode(
                          item.accountRegisterId
                        ),
                      };
                      const retVal = await accountStore.approveReject(reqdata);
                      accountStore.isworking = false;
                      if (retVal.success) {
                        notification.success({
                          message: "SPARS Feedback",
                          description: `request,${reqdata.reqcode} approved successfully with notifications`,
                        });
                      }

                      if (retVal.success === false) {
                        notification.success({
                          message: "SPARS Feedback",
                          description: `${reqdata.msg} `,
                        });
                      }
                    } catch (error) {
                      const { body } = error.response;
                      notification.error({
                        message: "SPARS Feedback",
                        description: body.message,
                      });
                    }
                  }}
                />
              </Tooltip>,
              <Tooltip title="Reject" key="Reject">
                <Button
                  type="link"
                  icon={
                    <CloseOutlined
                      style={{ color: "red" }}
                      onClick={async () => {
                        const reqdata = {
                          requestId: item.accountRegisterId,

                          reqcode: generateNewAccountRequestCode(
                            item.accountRegisterId
                          ),
                        };
                        accountStore.selReqItem = reqdata;
                        accountStore.showRejectRequestDialog = true;
                      }}
                    />
                  }
                />
              </Tooltip>,
            ]}
          >
            <Card.Meta
              avatar={
                <Persona
                  text={`${item.lastName} ${item.firstName}`}
                  secondaryText={item.jobFunction}
                  size={PersonaSize.size48}
                />
              }
              title={
                <TooltipHost content="request reference code">
                  <div
                    style={{
                      textAlign: "right",
                      color: "red",
                      fontSize: "12px",
                    }}
                  >
                    {generateNewAccountRequestCode(item.accountRegisterId)}
                  </div>
                </TooltipHost>
              }
            />
            <div
              className="ms-Grid"
              dir="ltr"
              style={{
                marginTop: "10px",
                fontSize: "12px",
                display: "flex",
                flexDirection: "row",
                overflowWrap: "break-word",
              }}
            >
              <div className="ms-Grid-row" style={styles.bodyrow}>
                <div
                  className="ms-Grid-col ms-sm12"
                  style={{ textOverflow: "ellipsis" }}
                >
                  <Link href={`mailto:${item.email}`}>
                    <TooltipHost content="requestor email">
                      {item.email}
                    </TooltipHost>
                  </Link>
                </div>
              </div>
            </div>
            <div className="ms-Grid-row" style={styles.bodyrow}>
              <div className="ms-Grid-col ms-sm5">
                {" "}
                <TooltipHost content="requestor phone or office extension">
                  {" "}
                  <Link href={`tel:${item.extension}`}>{item.extension}</Link>
                </TooltipHost>
              </div>
              <div
                className="ms-Grid-col ms-sm7"
                style={{ textAlign: "right" }}
              >
                <TooltipHost content="requestor department">
                  {" "}
                  {item.departmentName} ({item.code})
                </TooltipHost>
              </div>
            </div>
            <div className="ms-Grid-row" style={styles.bodyrow}>
              <div className="ms-Grid-col ms-sm8">
                <TooltipHost content="requestor company">
                  {item.company}
                </TooltipHost>
              </div>
              <div
                className="ms-Grid-col ms-sm4"
                style={{ textAlign: "right", ...styles.bodytext }}
              >
                <div className="pill accountpill">{item.userType}</div>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div
                className="ms-Grid-col ms-sm12"
                style={{
                  marginBottom: "-10px",
                  textAlign: "right",
                  marginTop: "10px",
                }}
              >
                <ClockCircleOutlined style={{ color: "#CBD5E0" }} />{" "}
                <span style={{ fontSize: "10px", color: "#718096" }}>
                  {moment(new Date(item.requestDate)).fromNow()}
                </span>
              </div>
            </div>
          </Card>
        </List.Item>
      )}
    />
  );
});

